import React from 'react';
import { DepositTakingBankListItem } from 'types';
import { BanksHero } from '../BanksHero';
import BankList from '../BankList/v2';

interface BanksProps {
  banksList: { entries: DepositTakingBankListItem[]; total: number };
}

const Banks: React.FC<BanksProps> = ({ banksList }) => (
  <>
    <BanksHero />
    {banksList && <BankList banks={banksList.entries} />}
  </>
);

export default Banks;
